/**
 * Builds a privacy-safe page path for analytics page views.
 *
 * Query params are allowlisted only — unknown/sensitive params (phone, tokens,
 * redirect URLs, etc.) are dropped.
 */

const ALLOWED_QUERY_PARAMS = new Set([
    'resultcode', // imID result pages
    'errorcode', // /error?errorCode=error1001
    'message', // /error?message=SumSubError
]);

/**
 * @param pathname - e.g. `/imid-verification-result`
 * @param search - e.g. `?phoneNumber=...&resultCode=200` (with or without `?`)
 */
export function toAnalyticsPagePath(
    pathname: string,
    search: string = ''
): string {
    const path = pathname || '/';
    if (!search || search === '?') {
        return path;
    }

    const raw = search.startsWith('?') ? search.slice(1) : search;
    const params = new URLSearchParams(raw);
    const safe = new URLSearchParams();

    params.forEach((value, key) => {
        if (ALLOWED_QUERY_PARAMS.has(key.toLowerCase())) {
            safe.set(key, value);
        }
    });

    const qs = safe.toString();
    return qs ? `${path}?${qs}` : path;
}
